













import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace, State, Action } from 'vuex-class'
import CommonDetail from './component/commonDetail.vue'
const billDetail = namespace('billDetail')
@Component({
  name: '',
  components: {
    CommonDetail
  }
})
export default class orderInstall extends Vue {
  @billDetail.Action queryBillInstallDetail
  @billDetail.State billInstallDetailData
  pra: any = {}
  //   billInstallDetailData: any = {
  //     title: '[2/3期]【北京 至 三亚】MU1107',
  //     installPrincipal: '789',
  //     installCommison: '23',
  //     penaltyInteres: '345.0',
  //     shouldAlso: '1234',
  //     installDate: '2034-10-09',
  //     flag: 0, // 是否逾期 0未逾期  1逾期
  //     list: [
  //       { amount: '70.34', date: '2039-09-05' },
  //       { amount: '78', date: '2039-12-15' },
  //       { amount: '20.34', date: '2039-12-25' }
  //     ]
  //   }
  created() {
    let data = this.$route.query
    //请求参数
    let params = {
      billNo: this.$route.query.billNo,
      debtNo: this.$route.query.debtNo,
      debtType: this.$route.query.debtType
    }
    // 组件参数
    this.pra = {
      flag: data.flag, // 用来判断是否逾期
      debtNo: data.debtNo, // 借据编号
      loanAcno: data.loanAcno
    }
    this.queryBillInstallDetail(params)
  }
}
